import { ApiFullTagDescription, LIST_TAG, api } from "..";
import { Follow } from "@/types/follow";

export const followApi = api.injectEndpoints({
  endpoints: (build) => ({
    //我的关注列表
    getFollows: build.query<Follow[], string >({
      query: (user_id ) => `/follows/${user_id}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags: (result, error, arg) => {
        const tags: ApiFullTagDescription[] = [{ id: "Follow", type: LIST_TAG }];
        if (result) {
          // and individual tags for each content
          tags.push(...result.map(({ id }) => ({ type: "Follow" as const, id: id })));
        }
        return tags;
      },
    }),
    //我的粉丝列表
    getFans: build.query<Follow[], string>({
      query: (user_id) => `/follows/${user_id}/fans`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags: (result, error, arg) => {
        const tags: ApiFullTagDescription[] = [{ id: "Fans", type: LIST_TAG }];
        if (result) {
          // and individual tags for each content
          tags.push(...result.map(({ id }) => ({ type: "Fans" as const, id: id })));
        }
        return tags;
      },
    }),
    //我的黑名单列表
    getBlackList: build.query<Follow[], string>({
      query: (user_id) => `/follows/${user_id}/blacklist`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags: (result, error, arg) => {
        const tags: ApiFullTagDescription[] = [{ id: "Black", type: LIST_TAG }];
        if (result) {
          // and individual tags for each content
          tags.push(...result.map(({ id }) => ({ type: "Black" as const, id: id })));
        }
        return tags;
      },
    }),
    //创建关注
    createFollow:build.mutation<Follow,Omit<Follow,"id|contents">>({
      query:(body)=>({
        url:'/follows',
        method:'POST',
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: (result, error, arg) => [{ type: 'Fans', id: arg.id }],
    }),
    // 取消关注
    deleteFollow:build.mutation<Follow,Omit<Follow,"contents">>({
      query:(body)=>({
        url:'/follows',
        method:'DELETE',
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: (result, error, arg) => [{ type: 'Follow', id: arg.id }],
    }),
    // 更新关注权限
    updateFollow:build.mutation<Follow,Omit<Follow,"contents">>({
      query:(body)=>({
        url:'/follows',
        method:'PUT',
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: (result, error, arg) => [{ type: 'Follow', id: arg.id }],
    }),
    // 更新粉丝权限
    updateFans:build.mutation<Follow,Omit<Follow,"contents">>({
      query:(body)=>({
        url:'/follows/fans',
        method:'PUT',
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: (result, error, arg) => [{ type: 'Fans', id: arg.id }],
    })
  }),
});

export const { 
  useLazyGetFollowsQuery, 
  useLazyGetFansQuery,
  useLazyGetBlackListQuery,
  useCreateFollowMutation,
  useDeleteFollowMutation,
  useUpdateFollowMutation,
  useUpdateFansMutation 
} = followApi;
